import { UTM_KEYS } from 'library/constants'

# Look for clicks on links and add UTM params if they wouldn't otherwise be
# handled by client side navigation.  This handles non-nuxt-links.
export addUtmParamsToAnchorsOnClick = ->
	document.body.addEventListener 'click', (event) ->
		el = event.target
		while el != document.body

			# If the element was an anchor tag, update it's href. This gets processed
			# before the redirect so the UTMs will be present in the URL. This
			# appears to be how GA4 cross domain tracking works.
			if el.nodeName == 'A'
				return unless href = el.getAttribute 'href'
				return if href == (newUrl = addCurrentUtmToUrl href)
				return el.setAttribute 'href', newUrl

			# Prepare to check parent
			return unless el = el.parentNode

# Add the curernt UTM query parms to a URL
export addCurrentUtmToUrl = (url) ->

	# Don't act if there are no query params in target
	currentParams = new URLSearchParams location.search.substr 1
	return url unless Array.from(currentParams.keys()).length > 0

	# Build objects for the target URL and the current URL
	targetUrl = new URL url, process.env.URL
	targetParams = targetUrl.searchParams

	# Loop through the current query parms
	mutated = false
	currentParams.forEach (val, key) ->

		# Only act on UTM query parms
		return unless key in UTM_KEYS

		# Don't override utm params that are in the target url
		return if targetParams.has key

		# Add the utm param to the target params
		if val != targetParams.get key
			targetParams.set key, val
			mutated = true

	# If the params wern't changed, return the originla URL so we can easily
	# test for changes
	return url unless mutated

	# Set replace the query string of the target url
	targetUrl.search = "?#{targetParams.toString()}"
	return targetUrl.toString()
